/**
 * Deal 作成フローの URL ルートパラメータ（`$direction`）と
 * Contract の `DealDirection` enum を変換するフロントエンド固有のヘルパー。
 *
 * これらは `@standandforce/api-contract` には含まれない（ルーティング都合の値）ため、
 * ルート層でローカルに定義する。
 */
import type { DealDirection } from '@standandforce/api-contract';
export const dealDirectionParamValues = ['inbound', 'outbound'] as const;
export type DealDirectionParam = (typeof dealDirectionParamValues)[number];
export const dealDirectionFromParam = (param: DealDirectionParam): DealDirection => param.toUpperCase() as DealDirection;